module.exports = __webpack_public_path__ + "img/sxsjs5.946b9b5b.png";